import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';

import s from './ModalWrapper.css';

class ModalWrapper extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    children: PropTypes.node,
  };

  static defaultProps = {
    children: null,
  };

  render() {
    return (
      <React.Fragment>
        {this.props.show &&
          <ModalContainer
            modalCN={s.modal}
            onClose={this.props.toggleModal}
            isOpen={this.props.show}
          >
            <div className={s.rootModal}>
              <div className={s.rootModalContainer}>
                {this.props.children}
                <i className={`fa fa-times ${s.closeBtnIcon}`} onClick={this.props.toggleModal} />
              </div>
            </div>
          </ModalContainer>}
      </React.Fragment>
    );
  }
}

export default withStyles(s)(ModalWrapper);



// WEBPACK FOOTER //
// ./src/shared/components/ModalWrapper/ModalWrapper.js